/* import __COLOCATED_TEMPLATE__ from './loading-card.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();